import React from 'react';

// tslint:disable max-line-length
const RIntroContentRemoteMuseumTranscriptionDemo: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. So... this gift has been made for you. I’ll explain. Someone at the museum wanted to share the objects in this gift with you and recorded messages for each one. Tap continue and I’ll see you on the other side.</p>
  </>
);

export {
  RIntroContentRemoteMuseumTranscriptionDemo,
};
